import * as swcHelpers from '@swc/helpers';
import { verify } from 'specified';
import { ResponseError } from './response-error.js';

const okOrThrow = (response)=>{
    if (!response.ok) {
        const error = new ResponseError(`Request to ${response.url} failed: ${response.status} - ${response.statusText}.`, response.status);
        throw error;
    }
};
function okOrThrowWithResponseError(response, responseMapper) {
    return _okOrThrowWithResponseError.apply(this, arguments);
}
function _okOrThrowWithResponseError() {
    _okOrThrowWithResponseError = swcHelpers.asyncToGenerator(function*(response, responseMapper) {
        if (response.ok) {
            return;
        }
        let isHandled = false;
        try {
            const result = yield response.json();
            const error = new ResponseError(result.message, response.status, responseMapper === null || responseMapper === void 0 ? void 0 : responseMapper(result));
            isHandled = true;
            throw error;
        } catch (error) {
            // check if the error is already handled
            if (isHandled) {
                throw error;
            }
            // otherwise fallback to default error handling
            okOrThrow(response);
        }
    });
    return _okOrThrowWithResponseError.apply(this, arguments);
}
const unwrapResponse = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(response, options = {}) {
        if (response.status === 422) {
            return response.json().then((error)=>{
                throw error;
            });
        }
        if (options.useResponseError || options.responseErrorMapper) {
            yield okOrThrowWithResponseError(response, options.responseErrorMapper);
        } else {
            yield okOrThrow(response);
        }
        return yield response.json();
    });
    return function unwrapResponse(response) {
        return _ref.apply(this, arguments);
    };
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const validateResponse = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(spec, response) {
        okOrThrow(response);
        const { err , value  } = verify(spec, (yield response.json()));
        if (err) {
            throw err;
        }
        return value();
    });
    return function validateResponse(spec, response) {
        return _ref.apply(this, arguments);
    };
}();

export { okOrThrow, unwrapResponse, validateResponse };
//# sourceMappingURL=response.js.map
